import { default as BrandVsNonBrand } from '../assets/brand-vs-non-brand.svg?react';
import { default as ClosersVsNonClosers } from '../assets/closers-vs-non-closers.svg?react';
import { default as ConceptScreening } from '../assets/concept-screening.svg?react';
import { default as ExpandersContractors } from '../assets/expanders-contractors.svg?react';
import { default as GenericPlaceholder } from '../assets/generic-placeholder.svg?react';
import { default as HeavyMediumLight } from '../assets/heavy-medium-light.svg?react';
import { default as LapsedRepeatNew } from '../assets/lapsed-repeat-new.svg?react';
import { default as LapsingBrand } from '../assets/lapsing-brand.svg?react';
import { default as Leakage } from '../assets/leakage.svg?react';
import { default as Monadic } from '../assets/monadic.svg?react';
import { default as NewItemLaunch } from '../assets/new-item-launch.svg?react';
import { default as NewItem } from '../assets/new-item.svg?react';
import { default as Promo } from '../assets/promo.svg?react';
import { default as PurchaseJourney } from '../assets/purchase-journey.svg?react';
import { default as QuickPulse } from '../assets/quick-pulse.svg?react';
import { default as TURF } from '../assets/turf.svg?react';
import { default as Video } from '../assets/video.svg?react';

export { default as LapsingBrand } from '../assets/lapsing-brand.svg?react';

/**
 * gets survey icon based on id
 * @param  {String} id
 * @return {Node}   react component
 */
export const getSurveyIcon = (id) => {
  switch (id) {
    case 'brand-vs-non-brand-buyers-v3-instant-survey-type':
      return <BrandVsNonBrand />;
    case 'buyer-instant-survey-type':
    case 'buyer-v2-instant-survey-type':
    case 'buyer-v3-instant-survey-type':
    case 'promo-instant-survey-type':
    case 'standard-v3-instant-survey-type':
      return <Promo />;
    case 'closers-vs-non-closers-v3-instant-survey-type':
      return <ClosersVsNonClosers />;
    case 'concept-screening-instant-survey-type':
    case 'concept-screening-v2-instant-survey-type':
    case 'concept-screening-v3-instant-survey-type':
    case 'concept-test-v3-instant-survey-type':
      return <ConceptScreening />;
    case 'expanders-contractors-v3-instant-survey-type':
      return <ExpandersContractors />;
    case 'heavy-medium-light-v3-instant-survey-type':
      return <HeavyMediumLight />;
    case 'lapsed-repeat-new-instant-survey-type':
    case 'lapsed-repeat-new-v3-instant-survey-type':
      return <LapsedRepeatNew />;
    case 'lapsing-brand-instant-survey-type':
    case 'lapsing-brand-v2-instant-survey-type':
    case 'lapsing-brand-v3-instant-survey-type':
      return <LapsingBrand />;
    case 'leakage-instant-survey-type':
    case 'leakage-v2-instant-survey-type':
    case 'leakage-v3-instant-survey-type':
      return <Leakage />;
    case 'monadic-concept-test-v3-instant-survey-type':
      return <Monadic />;
    case 'new-item-launch-instant-survey-type':
      return <NewItemLaunch />;
    case 'new-item-v3-instant-survey-type':
      return <NewItem />;
    case 'purchase-journey-instant-survey-type':
    case 'purchase-journey-v2-instant-survey-type':
    case 'purchase-journey-v3-instant-survey-type':
      return <PurchaseJourney />;
    case 'quick-pulse-instant-survey-type':
    case 'quick-pulse-v2-instant-survey-type':
    case 'quick-pulse-v3-instant-survey-type':
      return <QuickPulse />;
    case 'turf-v3-instant-survey-type':
      return <TURF />;
    case 'video-survey-v3-instant-survey-type':
      return <Video />;
    default:
      return <GenericPlaceholder />;
  }
};
